import { ResearchDetailCategory } from './researchDetailCategory';

export interface IAppState {
    researchDetailCategory: {}
}

export function rootReducer(state: IAppState, action): IAppState {
    switch (action.type) {
        case 'UPDATE_CATEGORY':
            return Object.assign({}, state, {
                categoryStatus: action.category
            })
    }
    return state;
}

export const INITIAL_STATE: IAppState = {
    researchDetailCategory: {}
}


// WEBPACK FOOTER //
// ./src/app/stateManagement/state.ts